import React from "react";
import extension from '../../assets/images/extension-pic.svg';
import external from '../../assets/images/external.svg';

export default function ExtensionPopup(props: any) {

   return (
       <div className="popup extension-popup round-corner width-600">
          <div className="extension-img-sec">
             <div className="extension-img icon">
                <img src={extension} alt=""/>
             </div>
          </div>
          <div className="extension-details">
             <div className="details">
                <div className="rubik-medium font-24">Install Floik extension</div>
                <div className="font-14 margin-t-30 margin-b-30">
                   Please add Floik extension to your browser to create a flo
                </div>
                <button className="btn round-corner-8 item-height-35">
                   <div className="flex font-13">
                      <div className="">Visit chrome web store</div>
                      <div className="icon width-18 margin-l-5">
                         <img src={external} alt=""/>
                      </div>
                   </div>
                </button>
             </div>
          </div>
       </div>
   )
}
